import { useCallback } from 'react';
import { useAnnotationToolbarContext } from '../../Annotation/AnnotationToolbarContext';
import { getHighlightPosition } from '../utils/highlightPositionUtils';
import { getToolbarPosition } from '../utils/toolbarUtils';

export function useTextSelection() {
  const { openToolbarForSelection } = useAnnotationToolbarContext();

  const handleTextSelection = useCallback(() => {
    const windowSelection = window.getSelection();

    /* Clear selection state if no selection or if selection type is Caret (i.e.,
    the caret is placed on some text, but no range has been selected). */
    if (!windowSelection || windowSelection.type !== 'Range') {
      return;
    }

    const text = windowSelection.toString().trim();
    if (!text) {
      return;
    }

    const highlightPosition = getHighlightPosition(windowSelection);

    if (!highlightPosition) {
      // We cannot create annotation without position data
      return;
    }

    // Get the selection bounds
    const range = windowSelection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    const toolbarPosition = getToolbarPosition(rect);

    openToolbarForSelection(toolbarPosition, text, highlightPosition);
  }, [openToolbarForSelection]);

  return {
    handleTextSelection,
  };
}
